const STORAGE_KEY = 'due_perf_metrics';
const MAX_ENTRIES = 200;

export function recordPerfMetric(screen, action, durationMs, details = {}) {
  try {
    const entry = {
      screen: (screen || 'unknown').toString(),
      action: (action || 'load').toString(),
      durationMs: Number(durationMs) || 0,
      details: details || {},
      at: new Date().toISOString(),
    };
    const current = JSON.parse(window.localStorage.getItem(STORAGE_KEY) || '[]');
    const next = [entry, ...current].slice(0, MAX_ENTRIES);
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(next));
  } catch (_) {
    // Métrica não deve quebrar fluxo principal da tela.
  }
}

